import React, { FC, useState, useRef, useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";
import SlidingIconButton from "./SlidingIconButton";
import { useLocation } from "wouter";
import SortingDropdown from "../SortingDropdown";
import { useStore } from "../../store/store";

const SortingButton: FC = () => {
  const { isTourOpen } = useStore();
  const [, navigate] = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // React Spring animation for sliding in from the left
  const animationProps = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: isDropdownOpen ? 1 : 0,
    },
    config: {
      tension: 280,
      friction: 20,
    },
    delay: 100,
  });

  const sortings = [
    {
      label: "Tijd van oorsprong",
      segment: "timeline",
      action: () => navigate(`/timeline`),
    },
    {
      label: "Categorie",
      segment: "categories",
      action: () => navigate(`/sorting/categories`),
    },
  ];
  const [selected, setSelected] = useState<{
    label: string;
    segment: string;
    action: () => void;
  }>();

  const onClick = () => {
    setIsDropdownOpen(true);
  };

  const onSelectionChange = (selection: {
    label: string;
    segment: string;
    action: () => void;
  }) => {
    setSelected(selection);
    selection.action();
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="relative" ref={dropdownRef}>
      <SlidingIconButton
        color="text-white"
        text="Sorteren"
        iconClass="d-menu-dialpad"
        className={`button-sorting hover:w-[6.5rem] hover:border-sunshineYellow`}
        onClick={onClick}
        openByDefault={false}
        reverse={false}
        disabled={isTourOpen}
      />
      {isDropdownOpen && (
        <animated.div
          style={animationProps}
          className="absolute top-0 md:top-0 right-0 md:right-0 border-[#ffffff80] border-2 rounded-[24px] text-white bg-black backdrop--tinted flex-col px-2 text-sm flex sort-dropdown active"
        >
          <div className="flex h-10 items-center">
            <span className="d-icon h-full text-base mr-2 d-menu-dialpad flex items-center"></span>
            <span className="flex items-center justify-center expanding-text">
              Sorteren
            </span>
          </div>
          <SortingDropdown
            sortings={sortings}
            selected={selected}
            onSelectionChange={onSelectionChange}
          />
        </animated.div>
      )}
    </div>
  );
};

export default SortingButton;
